export default "__VITE_ASSET__iszjL1IM__"